import { useStore } from 'zustand';
import type { Game } from '@/game/Game';
import { useI18n } from '@/ui/i18n/I18nProvider';
import { useServices } from '@/ui/services/ServicesContext';
import { UndoIcon } from './Icons';
import styles from './UndoBar.module.css';

/** Undo / redo for organizing (plan §3.1). Hidden when there is nothing to undo, and during mini games. */
export function UndoBar({ game }: { game: Game }) {
  const { t } = useI18n();
  const { undo } = useServices();
  const { canUndo, canRedo } = useStore(undo.ui);
  const miniGame = useStore(game.miniGameUi, (s) => s.run !== null);
  const dragging = useStore(game.placementUi, (s) => s.dragging !== null);
  if (miniGame || dragging || (!canUndo && !canRedo)) return null;
  return (
    <div className={styles.bar}>
      <button
        type="button"
        className={styles.button}
        disabled={!canUndo}
        aria-label={t('ui.hud.undo')}
        title={t('ui.hud.undo')}
        onClick={() => {
          undo.undo();
        }}
      >
        <UndoIcon />
      </button>
      <button
        type="button"
        className={styles.button}
        disabled={!canRedo}
        aria-label={t('ui.hud.redo')}
        title={t('ui.hud.redo')}
        onClick={() => {
          undo.redo();
        }}
      >
        <UndoIcon flip />
      </button>
    </div>
  );
}
